<template lang="pug">
.k-card-modal
  v-dialog(
    v-bind="$data.$_attrs"
    v-on="$data.$_listeners"
    :max-width="maxWidth"
    :scrollable="scrollable"
  )
    k-card(
      :closable="closable"
      @close="$emit('input', false)"
      v-bind="cardProps"
    )
      slot(name="header-outer" v-if="hasHeaderSlot")
        k-card-text.title--semi-large.font-weight-bold.font-family--secondary
          slot(name="header")
        v-divider
      k-card-text(v-bind="cardProps").overflow-y-auto
        slot
</template>

<script>
import { BindsAttrs } from '@/mixins'

export default {
  mixins: [ BindsAttrs ],
  props: {
    cardProps: {
      type: Object,
      default: () => {}
    },
    showGirl: {
      type: Boolean,
      default: false
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    closable: {
      type: Boolean,
      default: false
    },
    // In the modal designs, the largest I saw was 548 so I went with this number
    maxWidth: {
      type: [ Number, String ],
      default: 548
    }
  },
  computed: {
    hasHeaderSlot () {
      return this.$slots.header || this.$slots['header-outer']
    }
  },
}
</script>
